@if (versionInfo) {
  <div class="text-small-extra app-version break-word" data-role="app-version">
    @if (!versionInfo.isOutdated) {
      <a
        class="link-version"
        [matTooltip]="upToDateTooltip"
        (click)="checkIsOutdated()"
        >{{ versionInfo?.localVersion }}<mat-icon>check</mat-icon>
      </a>
    }
    @if (versionInfo.isOutdated) {
      <a
        class="link-version"
        [matTooltip]="outdatedTooltip"
        (click)="updateApp()"
        >{{ versionInfo?.localVersion }}<mat-icon>warning</mat-icon>
      </a>
    }
  </div>
}
